<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i *ngIf="this.id && !visualizar" class="fas fa-pencil-alt pr-2"></i>
        <i *ngIf="this.id && visualizar" class="fas fa-search pr-2"></i>
        <i *ngIf="!this.id" class="far fa-file pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body wrapper">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
        <div class="row mb-2">

            <div class="col-md-2 mb-2">
                <label for="inputIdentificador" class="mb-1">Identificador</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputIdentificador" class="form-control form-control-sm" readonly
                        [value]="model.identificador === 0 ? '-' : model.identificador" />
                </div>
            </div>

            <div class="col-md-4 mb-2">
                <label for="inputStatus" class="mb-1">Status</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputStatus" class="form-control form-control-sm" readonly
                        [value]="model.status?.descricao" />
                </div>
            </div>

            <div class="col-md-6 mb-2" *ngIf="aposAvaliacao">
                <label for="inputNivel" class="mb-1">Nível da Ação</label>
                <input type="text" id="inputNivel" class="form-control form-control-sm" readonly
                    [value]="model.nivelRelevancia?.descricao || ''" />
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputTitulo" class="mb-1">Título da Ação</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputTitulo" class="form-control form-control-sm" maxlength="200"
                        [(ngModel)]="model.titulo" [ngModelOptions]="{standalone: true}" [readonly]="visualizar" />
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputDescricao" class="mb-1">Descrição da Ação</label>
                <div>
                    <angular-editor *ngIf="!visualizar; else descricaoVisualizar" #maxLengthEditor
                        [config]="editorConfig" (keydown)="onEditorKeyDown($event)" [(ngModel)]="model.descricao"
                        [ngModelOptions]="{standalone: true}">
                    </angular-editor>
                    <ng-template #descricaoVisualizar>
                        <div class="form-control" [innerHTML]="model.descricao"
                            style="min-height: 150px; max-height: 180px; overflow-y: auto;">
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="col-md-8 mb-2">
                <label for="inputResponsavelId" class="mb-1">Responsável</label>
                <ng-select id="responsavelId" [readonly]="visualizar" name="responsavelId"
                    [(ngModel)]="model.responsavelId" placeholder="Selecione um responsável">
                    <ng-option *ngFor="let responsavel of responsaveis" [value]="responsavel.value">
                        {{ responsavel.text }} - {{ responsavel.naturezaResponsabilidade }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="col-md-4 mb-2">
                <label class="form-label">Prazo de Implementação</label>
                <input type="text" class="form-control form-control-sm" placeholder="DD/MM/AAAA" bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" [(ngModel)]="model.prazo"
                    [ngModelOptions]="{standalone: true}" [readonly]="visualizar" />
            </div>

            <div class="col-md-12 mb-2" *ngIf="!visualizar">
                <label for="inputRecomendacao" class="mb-1">Recomendação Relacionada</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputRecoemdacaoSel" class="form-control form-control-sm" readonly
                        [ngModel]="recomendacaoSelecionada?.titulo" [ngModelOptions]="{standalone: true}" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-info" (click)="exibirModalRecomendacao()"
                            title="Buscar Recomendações">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1" (click)="addRecomendacao()"
                            title="Adicionar a Recomendação selecionada na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-2" *ngIf="!visualizar && recomendacaoSelecionada?.descricao">
                <label for="inputRecomendacao" class="mb-1">Descrição</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <textarea class="form-control" rows="3" name="inputDescricaoRecoemdacaoSel" readonly
                        [ngModel]="recomendacaoSelecionada?.descricao" [ngModelOptions]="{standalone: true}">
                    </textarea>
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceRecomendacao" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['titulo', 'actions']" class="bg-light"></tr>
                        <ng-container matColumnDef="titulo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Recomendação</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.recomendacao?.titulo">-</span>
                                <span *ngIf="element?.recomendacao?.titulo">{{ element.recomendacao.titulo }}</span>
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                                        (click)="modalRecomendacao(element)">
                                        <i class="far fas fa-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirRecomendacao(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-row *matRowDef="let row; columns: ['titulo', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceRecomendacao.data?.length > 0">
                        Nenhuma recomendação vinculada
                    </h5>
                    <mat-paginator #tabelaRecomendacaoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>

            <!-- Ação adicionada após a avaliação do auditor -->
            <ng-container *ngIf="aposAvaliacao">
                <div class="col-md-12 mb-2">
                    <label class="mb-1 d-block">Avaliação do Auditor</label>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [checked]="false" disabled />
                        <label class="form-check-label">Aprovada</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [checked]="false" disabled />
                        <label class="form-check-label">Aprovada com Ressalvas</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [checked]="false" disabled />
                        <label class="form-check-label">Rejeitada</label>
                    </div>
                </div>

                <div class="col-md-12 mb-2">
                    <label class="mb-1">Justificativas</label>
                    <textarea class="form-control" rows="3" readonly [value]="textoAposAvaliacao"></textarea>
                </div>

                <div class="col-md-12 mb-2">
                    <label class="mb-1">Comentário da Avaliação</label>
                    <textarea class="form-control" rows="3" readonly [value]="textoAposAvaliacao"></textarea>
                </div>
            </ng-container>

        </div>
    </form>
</div>
<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <div class="btn-group" [hidden]="visualizar">
            <button class="btn btn-primary btn-sm mr" (click)="salvar()">
                <i class="far fa-save"></i> Salvar
            </button>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()" [hidden]="visualizar">
            <i class="fas fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()" [hidden]="!visualizar">
            <i class="fas fa-times"></i> Sair
        </button>
    </div>
</div>